const HERO_IMAGE =
  'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/6ee0a95679329564d8d4b406aa9270b6.png';

const MAPS_URL =
  'https://www.google.com/maps/dir/?api=1&destination=Cvetkovci%2050%2C%202273%20Podgorci';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="domov" className="relative w-full h-screen min-h-[600px] overflow-hidden bg-background-950">
      <div className="absolute inset-0 w-full h-full">
        <img
          src={HERO_IMAGE}
          alt="Gostilna Marta – domača slovenska gostilna"
          title="Gostilna Marta – tradicionalna slovenska gostilna"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/65"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
        <p className="hero-animate font-label text-xs md:text-sm tracking-extra-wide text-white/70 uppercase mb-4 md:mb-6">
          Tradicionalna slovenska gostilna
        </p>
        <h1 className="hero-animate font-heading text-5xl sm:text-6xl md:text-8xl lg:text-9xl font-light text-white tracking-wide mb-3 md:mb-4">
          GOSTILNA MARTA
        </h1>
        <p className="hero-animate font-heading text-xl sm:text-2xl md:text-3xl lg:text-4xl italic text-white/90 font-light mb-4 md:mb-6">
          Domača kuhinja. Toplina. Gostoljubje.
        </p>
        <p className="hero-animate font-body text-sm md:text-base text-white/75 max-w-lg mb-8 md:mb-10 leading-relaxed">
          .
        </p>
        <div className="hero-animate flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full px-6 sm:px-0 max-w-sm sm:max-w-none">
          <button
            onClick={() => scrollTo('ponudba')}
            className="w-full sm:w-auto px-7 py-4 sm:py-3 bg-primary-500 hover:bg-primary-600 text-background-950 text-sm sm:text-xs font-label font-semibold tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md sm:rounded-sm animate-pulse-glow"
          >
            OGLEJ SI PONUDBO
          </button>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-7 py-4 sm:py-3 border border-white/40 hover:border-white/80 text-white text-sm sm:text-xs font-label font-medium tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md sm:rounded-sm hover:bg-white/10 text-center"
          >
            KAKO DO NAS
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 md:bottom-12 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 animate-float">
          <span className="font-label text-[10px] md:text-xs tracking-extra-wide text-white/60 uppercase">
            ODKRIJ MARTO
          </span>
          <i className="ri-arrow-down-line text-white/60 text-lg"></i>
        </div>
      </div>
    </section>
  );
}